/**
 * Achievement Progress Bar Component
 * Shows progress for tiered achievements
 */

import React from 'react'
import { Box, LinearProgress } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { TieredAchievement } from '../types/achievementTypes'

export interface AchievementProgressBarProps {
  achievement: TieredAchievement
  className?: string
}

/**
 * AchievementProgressBar - Visual progress indicator for tiered achievements
 */
export const AchievementProgressBar: React.FC<AchievementProgressBarProps> = ({ achievement, className = '' }) => {
  const hasNextLevel = achievement.nextLevel !== undefined

  if (!hasNextLevel) {
    return null // Max level reached, no progress bar
  }

  return (
    <Box className={className} sx={{ width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={achievement.progressPercent}
        sx={{
          height: 8,
          borderRadius: '4px',
          backgroundColor: INTERAX_COLORS.heritageBlue40,
          '& .MuiLinearProgress-bar': {
            borderRadius: '4px',
            background: `linear-gradient(90deg, ${INTERAX_COLORS.sun} 0%, ${INTERAX_COLORS.heritageBlue} 100%)`
          }
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 0.5,
          fontSize: '12px',
          color: INTERAX_COLORS.typographyFont
        }}
      >
        <span>{achievement.currentValue}</span>
        <span>{Math.round(achievement.progressPercent)}%</span>
      </Box>
    </Box>
  )
}
